import {
  useRef,
  useState,
  useCallback,
  RefObject,
  useEffect,
  useMemo,
} from "react";
const basePos = {
  x: 0,
  y: 0,
};
export type DragState =
  | "start"
  | "move"
  | "end"
  | `limit-${string}`
  | undefined;
interface UseDragOptions {
  limit?: { x?: number; y?: number };
  absolute?: true;
  trigger?: boolean;
}
export const useDrag = (
  ref: RefObject<HTMLElement>,
  options: UseDragOptions = {}
) => {
  const { limit, absolute } = useMemo(() => options, [options]);
  const [pos, setPos] = useState(basePos);
  const [state, setState] = useState<DragState>();
  const startPosRef = useRef(basePos);
  const draggingRef = useRef<boolean>(false);

  const onTouchStart = useCallback((e: TouchEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const touch = e.touches[0];
    startPosRef.current = { x: touch.clientX, y: touch.clientY };
    draggingRef.current = true;
    setState("start");
  }, []);

  const onTouchMove = useCallback(
    (e: TouchEvent) => {
      if (!draggingRef.current) return;

      const touch = e.touches[0];
      console.log(touch.clientX - startPosRef.current.x);
      if (
        (limit?.x &&
          Math.abs(touch.clientX - startPosRef.current.x) > limit.x) ||
        (limit?.y && Math.abs(touch.clientY - startPosRef.current.y) > limit.y)
      ) {
        setState("end");
        draggingRef.current = false;
        return;
      }

      setPos({
        x: touch.clientX - (absolute ? 0 : startPosRef.current.x),
        y: touch.clientY - (absolute ? 0 : startPosRef.current.y),
      });
      setState("move");
    },
    [limit, absolute]
  );

  const onTouchEnd = useCallback(() => {
    draggingRef.current = false;
    setState("end");
  }, []);

  useEffect(() => {
    const currentRef = ref.current;
    currentRef?.addEventListener("touchstart", onTouchStart);
    currentRef?.addEventListener("touchmove", onTouchMove);
    currentRef?.addEventListener("touchend", onTouchEnd);
    currentRef?.addEventListener("touchcancel", onTouchEnd);

    return () => {
      currentRef?.removeEventListener("touchstart", onTouchStart);
      currentRef?.removeEventListener("touchmove", onTouchMove);
      currentRef?.removeEventListener("touchend", onTouchEnd);
      currentRef?.removeEventListener("touchcancel", onTouchEnd);
    };
  }, [ref, onTouchStart, onTouchMove, onTouchEnd, options?.trigger]);

  return { pos, state };
};
